/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_DeleteInputs */

const vi_grower_area_camera_delete = /** @type {(inputs: Grower_Area_Camera_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xoá camera`)
};

/**

* @param {Grower_Area_Camera_DeleteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_delete = /** @type {((inputs?: Grower_Area_Camera_DeleteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_DeleteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_delete(inputs)
});